import { render, staticRenderFns } from "./DwsLoading.vue?vue&type=template&id=2586deee&scoped=true"
import script from "./DwsLoading.vue?vue&type=script&lang=js"
export * from "./DwsLoading.vue?vue&type=script&lang=js"
import style0 from "./DwsLoading.vue?vue&type=style&index=0&id=2586deee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2586deee",
  null
  
)

export default component.exports